/** @file The host's quantised shake on world x of one moved point (CR-006, design 22.3 b). */
import type { ShakeWave } from '@zilo/pose3d-pose/contract';

/**
 * `(shakePx / ppu) sin(pi (t rate + (z' + y') spatial))` units with `t = floor(shakeClock stepHz) / stepHz` (`wave`), from
 * the moved `y'`, `z'`; 0 when `shakePx` is 0. `ppu` = authored pixels across per unit.
 */
export function hostShakeOf(y: number, z: number, shakePx: number, shakeClock: number, ppu: number, wave: ShakeWave): number {
  if (shakePx === 0) return 0;
  const t = Math.floor(shakeClock * wave.stepHz) / wave.stepHz;
  return (shakePx / ppu) * Math.sin(Math.PI * (t * wave.rate + (z + y) * wave.spatial));
}
